import { ApiConfig } from '@wbk/api';

ApiConfig.init({
  wbk: {
    api: process.env.VITE_PUBLIC_TICKETS_API_BASE!,
    authApi: process.env.VITE_PUBLIC_AUTH_API_BASE!,
    apiToken: process.env.VITE_PUBLIC_TICKETS_API_TOKEN!,
    appSource: process.env.VITE_PUBLIC_APP_SOURCE!,
    ticketingDomain: process.env.VITE_PUBLIC_BOOK_DOMAIN!,
  },
  grecaptcha: {
    v3Key: process.env.VITE_PUBLIC_CAPTCHA_KEY!,
  },
  cookie: {
    domain: process.env.VITE_COOKIE_DOMAIN!,
  },
});
